<div role="contentinfo">
  <div class="CFooterLinks urlLink" *ngIf="clientFooter?.ContentType === 'html'" [innerHTML]="clientFooter?.Value">
  </div>
  <div role="region" class="themed pageFooter" [attr.aria-label]="'AriaLabel_Footer'"
    [attr.fromts]="talentSuiteJS ? 'true from-ts' : ''">
    <div class="footerLinkContainer responsiveWidth footerMobile">
      <div class="prev themed pageFooter" *ngIf="footerNextPrevEnable('prev')">
        <a (click)="footerSlide('prev', 3)">
          <i class="fa fa-chevron-circle-left"></i><span class="UnderLineLink screenReaderText">{{ 'Lbl_PrevFooter' |
            translate }}</span>
        </a>
      </div>
      <span role="alert" class="screenReaderText" *ngIf="footerAlert">{{ footerAlert }}</span>
      <div class="footerLinkContSegment nga-default nga-fade" *ngIf="formattedFooter?.length">
        <ng-container *ngFor="let link of formattedFooter[footerIndex]">
          <div class="footerLink responsiveWidth" *ngIf="link?.Value || link?.Name">
            <a href="#" class="urlLink" *ngIf="link?.Value === 'gtgLocaleLink'" (click)="showLocalesDialog()"
              [attr.title]="translateStrings?.AriaLabel_LocaleOfSite.replace('[TOKEN_LOCALE]', response?.LocaleDesc)"
              [attr.aria-label]="translateStrings?.AriaLabel_LocaleOfSite.replace('[TOKEN_LOCALE]', response?.LocaleDesc)" [attr.aria-disabled]="disableClick ? 'true' : null" [attr.tabindex]="disableClick ? '-1' : null" [ngClass]="disableClick ? 'disableClick' : ''">
              <i class="fa fa-globe"></i><span>{{ response?.LocaleDesc }}</span>
            </a>
            <a class="urlLink" *ngIf="link?.Value && link?.Value !== 'gtgLocaleLink'" 
              [attr.href]="bConfigMode ? null : link.Value" [attr.title]="link.Name" [attr.aria-disabled]="disableClick ? 'true' : null" [attr.tabindex]="disableClick ? '-1' : null" [ngClass]="disableClick ? 'disableClick' : ''">
              <i class="fa far" [ngClass]="link.Icon"></i>
              <span [ngClass]="{ 'screenReaderText': link.onlyIcon === '1' }">
                {{ link.Name }}
              </span>
            </a>
          </div>
        </ng-container>
      </div>

      <div class="next themed pageFooter" *ngIf="footerNextPrevEnable('next')">
        <a (click)="footerSlide('next', 3)">
          <i class="fa fa-chevron-circle-right"></i>
          <span class="UnderLineLink screenReaderText">
            {{ 'Lbl_NextFooter' | translate }}
          </span>
        </a>
      </div>
    </div>

    <div class="responsiveWidth footerDesktop">
      <div class="footerLinkContainer tgLocale" *ngFor="let array of formattedFooter"
        [ngClass]="{ fullFooter: footerLinks.length === 1, semiFooter: footerLinks.length === 2 }">
        <div class="footerLink responsiveWidth" *ngFor="let link of array">
          <a href="#" class="urlLink" *ngIf="link?.Value === 'gtgLocaleLink'" (click)="showLocalesDialog()"
            capture-element="thisLocale"
            [attr.title]="translateStrings?.AriaLabel_LocaleOfSite.replace('[TOKEN_LOCALE]', response?.LocaleDesc)"
            [attr.aria-label]="translateStrings?.AriaLabel_LocaleOfSite.replace('[TOKEN_LOCALE]', response?.LocaleDesc)"
            [attr.aria-disabled]="disableClick ? 'true' : null" [attr.tabindex]="disableClick ? '-1' : null"
            [ngClass]="disableClick ? 'disableClick' : ''">
            <i class="fa fa-globe"></i>
            <span>{{ response?.LocaleDesc }}</span>
          </a>
          <a  class="urlLink" *ngIf="link?.Value !== 'gtgLocaleLink'"
            [attr.href]="bConfigMode ? null : link?.Value || null" [attr.title]="link?.Name"
            [attr.aria-disabled]="disableClick ? 'true' : null" [attr.tabindex]="disableClick ? '-1' : null"
            [ngClass]="disableClick ? 'disableClick' : ''">
            <i class="fa far" [ngClass]="link?.Icon"></i>
            <span [ngClass]="{ 'screenReaderText': link?.onlyIcon === '1' }"> {{ link?.Name }}</span>
          </a>
          <a href="#"  class="urlLink"
            *ngIf="!link?.Value && TgSettings.ShowCookieConsent === 'enhanced'" [attr.title]="link?.Name"
            [attr.aria-disabled]="disableClick ? 'true' : null" [attr.tabindex]="disableClick ? '-1' : null"
            [ngClass]="disableClick ? 'disableClick' : ''">
            <i class="fa far" [ngClass]="link?.Icon"></i>
            <span [ngClass]="{ 'screenReaderText': link?.onlyIcon === '1' }"> {{ link?.Name }}</span>
          </a>
        </div>
        <br />
      </div>
    </div>
  </div>
</div>

<div class="ngdialog ngdialog-theme-default leavingWarningContent" *ngIf="showLeaveDialog" role="dialog"
  aria-modal="true" id="ngdialog2">
  <div class="ngdialog-overlay" (click)="closeDialogs()"></div>
  <div class="ngdialog-content" (click)="$event.stopPropagation()">
    <button class="ngdialog-close backLink  Xclose Paddingbottom10" aria-label="Close"
      (click)="closeDialogs()"></button>
    <div class="leavingWarningDialog">
      <a class="backLink Xclose Paddingbottom10" (click)="closeDialogs()">
        <label class="UnderLineLink">{{ 'Link_Back' | translate }}</label></a>
      <div class="title">
        <h1>
          <span *ngIf="bSaveDraft">{{ 'Message_AboutToLeaveApplication' | translate }}</span>
          <span *ngIf="!bSaveDraft">{{ 'Message_AboutToLeaveSite' | translate }}</span>
        </h1>
      </div>
      <div id="dialogDesc">
        <div id="leaveSaveApp" class="message" *ngIf="bSaveDraft">
          <p>{{ 'Message_LeaveSaveAppDays' | translate }}</p>
        </div>
        <div id="areYouSure" class="question">
          <p>{{ 'Message_AreYouSure' | translate }}</p>
        </div>
      </div>
      <div class="buttons">
        <button class="primaryButton" (click)="closeThisDialog('0')">
          <span class="button-label">{{ 'Label_NoTakeMeBack' | translate }}</span>
        </button>
        <a class="goLink" role="link" (click)="closeThisDialog('1')">
          <span class="button-label">{{ 'Label_YesContinue' | translate }}</span>
        </a>
      </div>
    </div>
  </div>
</div>